export default __webpack_public_path__ + "static/media/settingicon.7d3108a1.svg";